var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-xs-center" },
    [
      _c(
        "v-dialog",
        {
          staticStyle: { "background-color": "transparent !important" },
          attrs: { fullscreen: "", persistent: "" },
          model: {
            value: _vm.coIsVisible,
            callback: function($$v) {
              _vm.coIsVisible = $$v
            },
            expression: "coIsVisible"
          }
        },
        [
          _c(
            "v-container",
            {
              staticClass: "v-overlay v-overlay--active pa-0",
              staticStyle: { "min-width": "100%" },
              attrs: { "fill-height": "" }
            },
            [
              _c(
                "v-flex",
                {
                  staticStyle: { "z-index": "1" },
                  attrs: { "offset-xs2": "" }
                },
                [
                  _c(
                    "v-layout",
                    { staticClass: "login--bg-default", attrs: { fluid: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { "offset-xs5": "", xs5: "" } },
                        [
                          _c(
                            "v-container",
                            {
                              attrs: {
                                fluid: "",
                                "fill-height": "",
                                "mb-5": ""
                              }
                            },
                            [
                              _c(
                                "v-container",
                                {
                                  attrs: {
                                    fluid: "",
                                    "fill-height": "",
                                    "pb-5": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { border: "none" },
                                      attrs: { "offset-xs2": "", xs8: "" }
                                    },
                                    [
                                      _c(
                                        "v-container",
                                        {
                                          staticClass: "whitePure pa-0",
                                          staticStyle: { border: "none" },
                                          attrs: { "fill-height": "" }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              staticStyle: { border: "none" },
                                              attrs: { wrap: "" }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "text-xs-center",
                                                  attrs: { xs12: "" }
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "pt-4",
                                                    staticStyle: {
                                                      width: "30%"
                                                    },
                                                    attrs: {
                                                      src:
                                                        "https://res.cloudinary.com/driveim/image/upload/v1507982038/logo_z9tlrs.png"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs12: "" } },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: { wrap: "" },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            !(
                                                              "button" in $event
                                                            ) &&
                                                            _vm._k(
                                                              $event.keyCode,
                                                              "enter",
                                                              13,
                                                              $event.key,
                                                              "Enter"
                                                            )
                                                          ) {
                                                            return null
                                                          }
                                                          $event.preventDefault()
                                                          return _vm.handleAuthorize(
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs12: "" } },
                                                        [
                                                          _vm.dtError
                                                            ? _c("div", {
                                                                staticClass:
                                                                  "error--text text-xs-center my-2",
                                                                domProps: {
                                                                  textContent: _vm._s(
                                                                    _vm.dtError
                                                                  )
                                                                }
                                                              })
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                _vm.lblSetting
                                                                  .lblEmail
                                                              ),
                                                              type: "email",
                                                              rules: [
                                                                _vm.rules
                                                                  .require,
                                                                _vm.rules.email
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.dtUserInfo
                                                                  .email,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.dtUserInfo,
                                                                  "email",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "dtUserInfo.email"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs12: "" } },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              type: "password",
                                                              label: _vm.$t(
                                                                _vm.lblSetting
                                                                  .lblPassword
                                                              ),
                                                              rules: [
                                                                _vm.rules
                                                                  .require
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.dtUserInfo
                                                                  .password,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.dtUserInfo,
                                                                  "password",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "dtUserInfo.password"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "mx-auto mb-3 login__btn-login",
                                                          attrs: {
                                                            loading:
                                                              _vm.coInProcess,
                                                            disabled:
                                                              _vm.coInProcess,
                                                            color: "turquoise"
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.handleAuthorize(
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "BTN_LOGIN"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d33de2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d33de2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/app/components/the-login-form/template.html
// module id = null
// module chunks = 